// export var SetUrlConst = "https://api.repotal.ae";
export var SetUrlConst = "https://api.portal.repotal.cloud";
// export var SetUrlConst = "https://api.repotal.com";

export var BaseUrl = SetUrlConst;

// export function _setBaseUrlToggle(url) {
//   SetUrlConst = url;
//   BaseUrl = url;
// }
